import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { invokeApi } from './common';
import { initVerificationAction } from './verification';

export function initOTPToken() {
	return invokeApi(
		'/api/account/otp_token/init',
		{
			credentials: 'same-origin'
		},
		(dispatch, data) => handleInitOTPToken(dispatch, data)
	)
}

function handleInitOTPToken(dispatch, data) {
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
		{
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/otp_revoke/2-step-verification');
			break;
		}
		case ACTION_TYPE.DONE:
		{
			browserHistory.push('/security/otp_revoke/done');
			break;
		}
		default:
			break;
	}
}


// WEBPACK FOOTER //
// ./app/actions/otpToken.js